// Copilote Jamora (assistant IA) — pure helpers for Paramètres › Copilote Jamora. UI only: the server validates everything again.

export const ASSISTANT_MODELS = [
  { value: "claude-haiku-5-5", label: "Claude Haiku 5.5", hint: "Recommandé : rapide et économique pour les questions du quotidien." },
  { value: "claude-sonnet-5-5", label: "Claude Sonnet 5.5", hint: "Plus précis sur les demandes complexes, environ 20 fois plus cher." },
];

// Same bounds as the server's registry (backend/settings/models.py, section « assistant »).
export const ASSISTANT_LIMITS = {
  monthly_budget_cents: { min: 0, max: 10_000_000 },
  daily_user_budget_cents: { min: 0, max: 1_000_000 },
  retention_days: { min: 7, max: 365 },
  max_tool_rounds: { min: 1, max: 12 },
  max_output_tokens: { min: 256, max: 8000 },
};

// Budgets are stored in US cents (integers, never floats); the form shows dollars with a comma or a dot.
export function centsToDollars(cents) {
  if (!Number.isInteger(cents)) return "";
  const whole = Math.floor(cents / 100);
  const rest = cents % 100;
  return rest ? `${whole},${String(rest).padStart(2, "0")}` : String(whole);
}

export function dollarsToCents(text) {
  const value = String(text ?? "").trim().replace(/\s/g, "").replace(",", ".");
  const match = /^(\d+)(?:\.(\d{1,2}))?$/.exec(value);
  if (!match) return null;
  return Number(match[1]) * 100 + Number((match[2] || "").padEnd(2, "0"));
}

export function integerOrNull(text) {
  const value = String(text ?? "").trim();
  return /^\d+$/.test(value) ? Number(value) : null;
}

export function withinLimits(key, value) {
  const limit = ASSISTANT_LIMITS[key];
  return Number.isInteger(value) && value >= limit.min && value <= limit.max;
}

// Converts the form (text fields) to the API payload; null when a field is invalid.
export function settingsFromForm(form) {
  const values = {
    model: form.model,
    monthly_budget_cents: dollarsToCents(form.monthly_budget),
    daily_user_budget_cents: dollarsToCents(form.daily_user_budget),
    retention_days: integerOrNull(form.retention_days),
    max_tool_rounds: integerOrNull(form.max_tool_rounds),
    max_output_tokens: integerOrNull(form.max_output_tokens),
  };
  const valid = ASSISTANT_MODELS.some((m) => m.value === values.model)
    && Object.keys(ASSISTANT_LIMITS).every((key) => withinLimits(key, values[key]));
  return valid ? values : null;
}

export function formFromSettings(settings) {
  return {
    model: settings.model,
    monthly_budget: centsToDollars(settings.monthly_budget_cents),
    daily_user_budget: centsToDollars(settings.daily_user_budget_cents),
    retention_days: String(settings.retention_days),
    max_tool_rounds: String(settings.max_tool_rounds),
    max_output_tokens: String(settings.max_output_tokens),
  };
}

export function formsEqual(a, b) {
  return Object.keys(a).every((key) => String(a[key]).trim() === String(b[key]).trim());
}

// Status line of the stored API key.
export function connectionStatus(connection) {
  if (!connection?.configured) return { tone: "muted", label: "Aucune clé enregistrée" };
  if (!connection.readable) return { tone: "warning", label: "Clé enregistrée mais illisible : ressaisissez-la" };
  return { tone: "ok", label: `Clé enregistrée, se termine par ${connection.last4}` };
}
